<template>
  <label
    :for="labelFor"
    class="form-group-label"
  >
    <slot>
      {{ convertedLabel }}
    </slot>
  </label>
</template>

<script>
import { upperFirst } from 'lodash/string';

export default {
  name: 'MLabel',
  props: {
    labelFor: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    convertedLabel() {
      return upperFirst(this.label);
    },
  },
};
</script>
